import { z } from 'zod';
import { dateValidation, coerceNumber } from '../../../validation';

export const EbpCaseSupportAuthorizationSchema = z.object({
  requested: z.boolean().optional(),
  rejected: z.boolean().optional(),
  notRequired: z.boolean().optional(),
});

export type EbpCaseSupportAuthorization = z.infer<
  typeof EbpCaseSupportAuthorizationSchema
>;

export const UpdateEbpCaseSupportAuthorizationLevelOneSchema = z.object({
  endDate: dateValidation(),
});

export const UpdateEbpCaseSupportAuthorizationLevelTwoSchema = z.object({
  endDate: dateValidation(),
  maxAppointments: coerceNumber(z.number()),
});

export const UpdateEbpCaseSupportAuthorizationLevelThreeSchema = z.object({
  maxAppointments: coerceNumber(z.number()),
});

export const UpdateEbpCaseSupportAuthorizationRejectedSchema = z.object({
  notes: z.string().optional(),
});

export const UpdateEbpCaseSupportAuthorizationNotRequiredSchema = z.object({
  notes: z.string().optional(),
});

export type UpdateEbpCaseSupportAuthorizationLevelOne = z.infer<
  typeof UpdateEbpCaseSupportAuthorizationLevelOneSchema
>;

export type UpdateEbpCaseSupportAuthorizationLevelTwo = z.infer<
  typeof UpdateEbpCaseSupportAuthorizationLevelTwoSchema
>;

export type UpdateEbpCaseSupportAuthorizationLevelThree = z.infer<
  typeof UpdateEbpCaseSupportAuthorizationLevelThreeSchema
>;

export type UpdateEbpCaseSupportAuthorizationRejected = z.infer<
  typeof UpdateEbpCaseSupportAuthorizationRejectedSchema
>;

export type UpdateEbpCaseSupportAuthorizationNotRequired = z.infer<
  typeof UpdateEbpCaseSupportAuthorizationNotRequiredSchema
>;
